export const MISSION_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "WebPage",
   "@id": "https://everest.ind.br/pt/missao/#webpage",
   "name": "Missão, Visão e Valores | Everest",
   "url": "https://everest.ind.br/pt/missao",
   "description": "Saiba mais sobre a missão, visão e os valores que levam a Everest a ser a melhor marca de purificadores e máquinas de gelo do Brasil, entregando sustentabilidade.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/#website"
   },
   "publisher": {
    "@id": "https://everest.ind.br/#organization"
   },
   "about": {
    "@id": "https://everest.ind.br/#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/missao/#breadcrumb"
   },
   "mainEntity": {
    "@id": "https://everest.ind.br/pt/missao/#mvv"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/missao/#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Missão, Visão e Valores",
     "item": "https://everest.ind.br/pt/missao"
    }
   ]
  },
  {
   "@type": "DefinedTermSet",
   "@id": "https://everest.ind.br/pt/missao/#mvv",
   "name": "Missão, Visão e Valores",
   "description": "Princípios institucionais da Everest que orientam suas estratégias, cultura organizacional e compromisso com clientes e sociedade.",
   "hasDefinedTerm": [
    {
     "@type": "DefinedTerm",
     "name": "Missão",
     "description": "Desenvolver e oferecer produtos e serviços confiáveis e eficientes que atendam às necessidades dos clientes, dedicando-se à qualidade e promovendo o bem estar."
    },
    {
     "@type": "DefinedTerm",
     "name": "Visão",
     "description": "Ser referência no segmento de atuação, sendo reconhecida por sua eficiência, qualidade e práticas sustentáveis."
    },
    {
     "@type": "DefinedTerm",
     "name": "Ética",
     "description": "Mantemos relações íntegras e respeitosas em todas as nossas interações."
    },
    {
     "@type": "DefinedTerm",
     "name": "Foco no cliente",
     "description": "Atuamos para atender às necessidades dos nossos clientes."
    },
    {
     "@type": "DefinedTerm",
     "name": "Qualidade em produtos e serviços",
     "description": "Nossas operações são direcionadas às necessidades, expectativas e percepções dos nossos clientes."
    },
    {
     "@type": "DefinedTerm",
     "name": "Sustentabilidade",
     "description": "Nossas práticas visam contribuir para que as gerações futuras tenham condições e recursos para atender suas necessidades."
    }
   ]
  }
 ]
}
